export const defaultID = 'None'
export const ID = 'None'
export const baseURL = 'https://res.cloudinary.com/dcmthd8bn/image/upload/ArtMixer'
export const resultURL = 'https://res.cloudinary.com/dcmthd8bn/image/upload'